

let exit_intent = {
  init: () => {
      document.getElementById('popup');

      // Attach copy event to each product title
      document.querySelectorAll('.product-title').forEach(title => {
      title.addEventListener('copy', function () {
        const rect = this.getBoundingClientRect();
            
            $('.exit-popup-modal').fadeIn();

        });
      });
      $('.exit-popup-close').on('click', function(e){
        e.preventDefault();
        // exit_intent.cookies.add("exitpopup","hide","7"); //You can set any number of days here.
        $('.exit-popup-modal').fadeOut();
      });
  },
  cookies: {
    add: (name, value, days) => {
      if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
      } else {
        var expires = "";
      }
      document.cookie = name+"="+value+expires+"; path=/";
    },
    read: (name) => {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    }
  }
}
exit_intent.init();